import React, { useEffect, useState, useContext } from "react";
import LoadingInfynito from "../Shared/LoadingInfynito";
import SwipeableDrawer from '@mui/material/SwipeableDrawer';

import Typography from '@mui/material/Typography';

import Button from '@mui/material/Button';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import DirectionsBoatFilledIcon from '@mui/icons-material/DirectionsBoatFilled';
import WebIcon from '@mui/icons-material/Web';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import CloseIcon from '@mui/icons-material/Close';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ScreenRotationIcon from '@mui/icons-material/ScreenRotation';

import InteractiveDeck from "../Arrangement/InteractiveDeck";
import StaticDeck from "../Arrangement/StaticDeck";
import Mood from "../Interiors/Mood";
import CustomizationContext from "../CustomizationContext";
import LocalizationContext from "../LocalizationContext";
import { Parser } from 'html-to-react';
import FooterFerrettiInfynito from "../Home/FooterFerrettiInfynito";

export const Configuration = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [openRecap, setOpenRecap] = useState(false);
    const [customization, setCustomization] = useState();
    const customizationCtx = useContext(CustomizationContext);
    const localizationCtx = useContext(LocalizationContext);

    const loadConfiguration = async (offX, offY) => {

        if (customizationCtx.customizationData.idCustomization !== '') {

            setIsLoading(true);

            const response = await fetch("/api/customization/get/" + customizationCtx.customizationData.idCustomization + "/" + customizationCtx.customizationData.language);

            if (response.ok) {
                const data = await response.json();
                if (data) {
                    setCustomization(data);
                } else {
                    props.feedbackCallback("error", "Error loading configuration", true);
                }

            } else {
                const error = await response.text();
                console.log(error);
                props.feedbackCallback("error", error, true);
            }
            setIsLoading(false);

            window.scrollTo(offX, offY);

        } else {
            if (props.returnUrl !== '') {
                window.location.href = props.returnUrl;
            }
        }
    }

    useEffect(() => {
        loadConfiguration(0, 0);
    }, []);

    const handleReturnLandingPage = () => {
        window.location.href = props.returnUrl;
    };

    const handleResetConfiguration = async () => {
        const response = await fetch("/api/customization/reset/" + customizationCtx.customizationData.idCustomization);

        if (response.ok) {
            const data = await response.json();
            if (data) {
                loadConfiguration(0, 0);
            } else {
                props.feedbackCallback("error", "Error resetting configuration", true);
            }

        } else {
            const error = await response.text();
            console.log(error);
            props.feedbackCallback("error", error, true);
        }
    }

    const handleRecapConfiguration = () => {
        setOpenRecap(true);
    }

    const closeRecap = () => {
        setOpenRecap(false);
    }

    const handleConfirmConfiguration = () => {
        props.updateStepCallBack(2);
    }

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setOpenRecap(open);
    };

    const actions = [
        ...(props.returnUrl !== '') ? [{ icon: <WebIcon style={{ color: 'white' }} />, name: localizationCtx.localizationData.toolTipLanding, action: handleReturnLandingPage }] : [],
        { icon: <RestartAltIcon style={{ color: 'white' }} />, name: localizationCtx.localizationData.toolTipReset, action: handleResetConfiguration },
        { icon: <DirectionsBoatFilledIcon style={{ color: 'white' }} />, name: localizationCtx.localizationData.toolTipRecap, action: handleRecapConfiguration },
        { icon: <AlternateEmailIcon style={{ color: 'white' }} />, name: localizationCtx.localizationData.toolTipConfirm, action: handleConfirmConfiguration },
    ];

    return (
        <>
            {isLoading &&
                <div className="py-5 bkg-white">
                    <LoadingInfynito message={localizationCtx.localizationData.loadingWait} />
                </div>
            }
            {!isLoading &&
                <>
                    <div className="content-wrap bkg-deep-ocean">
                        <div className="container-fluid bkg-white">
                            <div className="row py-5">
                                <div className="col-12">
                                    <p className="infynito-section-subtitle-dark text-center text-uppercase py-2">{localizationCtx.localizationData.configureSection1Title}</p>
                                    {/*<p className="text-infynito-section text-center">{localizationCtx.localizationData.configureSection1Text}</p>*/}
                                </div>
                                <div className="col-12 py-5 d-block d-sm-none text-center">
                                    <p className="text-infynito-section text-center">{localizationCtx.localizationData.landscapeMode2}</p>
                                    <p className="pt-5"><ScreenRotationIcon /></p>
                                </div>
                            </div>
                        </div>
                        <div className="d-none d-sm-block bkg-white">
                            <div className="col-12">
                                {customization.modelDecks.map((myDeck, i) => (
                                    <InteractiveDeck key={i} deck={myDeck} callBack={loadConfiguration} feedbackCallback={props.feedbackCallback} />
                                ))}
                            </div>
                            <div className="container-fluid bkg-sand">
                                <div className="row py-5">
                                    <div className="col-12">
                                        <p className="infynito-section-subtitle text-center py-2">{localizationCtx.localizationData.configureSection2Title}</p>
                                        <p className="text-infynito-section text-center">{localizationCtx.localizationData.configureSection2Text}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="container-fluid bkg-sand">
                                <div className="row py-5">
                                    <div className="col-12 pb-5">
                                        <Mood callBack={loadConfiguration} viewMode="conf" feedbackCallback={props.feedbackCallback} />
                                    </div>
                                </div>
                            </div>

                            <SwipeableDrawer
                                anchor="right"
                                open={openRecap}
                                onClose={toggleDrawer(false)}
                                onOpen={toggleDrawer(true)}
                            >
                                <div className="container bkg-deep-ocean">
                                    <div className="row d-flex justify-content-center align-items-center">
                                        <div className="col-10 d-flex justify-content-start">
                                            <p className="recap-title">
                                                {localizationCtx.localizationData.lateralBarTitle}</p>
                                        </div>
                                        <div className="col-2 d-flex justify-content-end">
                                            <a className="close-recap" onClick={closeRecap}><CloseRoundedIcon style={{ color: 'white' }} /></a>
                                        </div>
                                    </div>
                                </div>

                                {customization.modelDecks.map((myDeck, i) => (
                                    <StaticDeck key={i} deck={myDeck} viewMode="recap" feedbackCallback={props.feedbackCallback} />
                                ))}

                                <Mood viewMode="recap" feedbackCallback={props.feedbackCallback} />

                                <div className="container py-5">
                                    <div className="row justify-content-center">
                                        <div className="col-10 text-center">
                                            <a className="flat-gray-button text-uppercase button-infynito-notactive button-text mt-5" onClick={handleConfirmConfiguration}>{Parser().parse(localizationCtx.localizationData.buttonConfirm)}</a>
                                        </div>
                                    </div>
                                </div>

                            </SwipeableDrawer>

                            <SpeedDial
                                ariaLabel="SpeedDial openIcon example"
                                sx={{ position: 'fixed', bottom: 16, right: 16 }}
                                icon={<SpeedDialIcon icon={<MenuOpenIcon />} openIcon={<CloseIcon />} />}
                            >
                                {actions.map((action) => (
                                    <SpeedDialAction
                                        key={action.name}
                                        icon={action.icon}
                                        tooltipTitle={action.name}
                                        onClick={action.action}

                                    />

                                ))}
                            </SpeedDial>
                        </div>
                    </div>
                    <FooterFerrettiInfynito cultureCode={props.cultureCode} />
                </>
            }
        </>
    );
};

export default Configuration;
